import { UserRole } from "@/shared/types";

export function getUserRoleOptions () {
  return [
    {
      value: UserRole.CustomerService,
      text: "Customer Service"
    },
    {
      value: UserRole.Admin,
      text: "Admin"
    },
    {
      value: UserRole.SecurityAdmin,
      text: "Security"
    },
    {
      value: UserRole.SalesRep,
      text: "Sales Rep"
    },
    {
      value: UserRole.FraudPrevention,
      text: "Fraud Prevention"
    },
    {
      value: UserRole.HoldOps,
      text: "Hold Operations"
    },
    {
      value: UserRole.HoldFraud,
      text: "Hold Fraud"
    }
  ];
}